import { render, staticRenderFns } from "./MetadataName.vue?vue&type=template&id=53e439bc&"
import script from "./MetadataName.vue?vue&type=script&lang=js&"
export * from "./MetadataName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports